import { Draggable } from "@hello-pangea/dnd";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { PropsDraggableItem } from "./types";
import CustomAccordion from "../../../../../../../../components/accordion";
import CatalogOption from "../..";
import { useCatalogStore } from "../../context";
import { findNodeById } from "./methods";
import { useStyles } from "./styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { icons } from "../../../../../../../../utils/icons";
import SimpleModal from "../../../../../../../../components/modal/simpleModal";


export const DraggableItemComponent = ({ index, item, depth, rootId, parentId }: PropsDraggableItem) => {
  const { setSelectedItem, deleteItem, setExpandedLevel, items } = useCatalogStore();

  const styles = useStyles()
  const { t } = useTranslation()
  const foundItem = findNodeById(items, item.id);
  const isExpanded = foundItem?.expand ?? false

  const [modal, setModal] = useState<{
    open: boolean
    title: string
    description?: string
    confirm: () => void,
  }>({
    open: false,
    title: '',
    description: '',
    confirm: () => { },
  })

  const closeModal = () => {
    setModal(prev => ({
      ...prev,
      open: false,
    }))
  }

  const handleDelete = () => {
    setModal(prev => ({
      ...prev,
      open: true,
      title: t('optionGroup.modal.confirmation'),
      description: t('optionGroup.modal.deleteItem'),
      confirm: () => {
        deleteItem(item.id)
        closeModal()
      },
    }))
  }

  const handleSelectItem = () => {
    if (parentId) {
      setSelectedItem(parentId, item)
    } else {
      setSelectedItem('root', item)
    }
  }

  const handleExpand = () => {
    setExpandedLevel(item.id)
  };

  return (
    <>
      <Draggable key={item.id} draggableId={item.id} index={index}>
        {(provided, snapshot) => (
          <Box
            key={item.id}
            ref={provided.innerRef}
            {...provided.draggableProps}
            sx={styles.container(snapshot.isDragging, depth % 2 == 0)}
          >
            <CustomAccordion
              title={
                <Box
                  sx={styles.headerCustom(depth % 2 === 0)}
                >
                  {/* Handler + texto */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      {...provided.dragHandleProps}
                      sx={{
                        cursor: "grab",
                        color: "grey.500",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <DragIndicatorIcon />
                    </Box>
                    <Typography fontWeight="bold">{item.label}</Typography>
                  </Box>

                  {/* Iconos de acción */}
                  <Box sx={styles.iconContainer}>
                    {item.isEditable &&
                      <Tooltip title={t('ToolTips.edit')}>
                        <IconButton size="small" onClick={handleSelectItem}>
                          {icons('edit')}
                        </IconButton>
                      </Tooltip>
                    }
                    {item.isEditable &&
                      <Tooltip title={t('ToolTips.delete')}>
                        <IconButton size="small" onClick={handleDelete}>
                          {icons('simple-close')}
                        </IconButton>
                      </Tooltip>
                    }
                    {!item.textInput && <Tooltip title={isExpanded ? t('ToolTips.collapse') : t('ToolTips.expand')}>
                      <IconButton size="small" onClick={handleExpand} sx={styles.rotate(isExpanded)}>
                        {icons('arrow-down')}
                      </IconButton>
                    </Tooltip>}
                  </Box>
                </Box>
              }
              description={
                <CatalogOption
                  parentId={item.id}
                  children={!isExpanded ? [] : item.children || []}
                  depth={(depth ?? 0) + 1}
                  rootId={parentId ? rootId : item.id}
                  level={item.level + 1}
                  id={item.id}
                  subCatalogId={item.subcatalog}
                />}
              expandIcon={null}
              expanded={isExpanded}
            />
          </Box>
        )}


      </Draggable>
      <SimpleModal
        open={!!modal.open}
        next={modal.confirm}
        back={closeModal}
        close={closeModal}
        description={modal.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        title={modal.title}
        loadingButton={false}
      />
    </>
  );
};
